module.exports = __webpack_public_path__ + "static/img/學會沿革.png";